import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';

import { Row } from './Row';
import { ExpansionToggleButton } from './ExpansionToggleButton';
import { TableWrapper } from './TableWrapper';
import { AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH } from '../constants';
import { AudienceCount } from '../../domain';
import { AUDIENCE_INSIGHTS_METER_FEATURE_FLAG } from '../../featureFlags';

type TableProps = {
  values: AudienceCount[];
  hasChart?: boolean;
};

export const Table = ({ values, hasChart = false }: TableProps) => {
  const { mode } = useExpansionContext();
  const hasMeterFeatureFlag = useFeatureFlag(AUDIENCE_INSIGHTS_METER_FEATURE_FLAG);
  const firstPage = values.slice(0, AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH);
  const subsequentPages = values.slice(AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH);
  const total = values.reduce((acc, { count }) => acc + count, 0);

  const hasMeterChart = hasChart && hasMeterFeatureFlag;

  return (
    <TableWrapper data-test="audience-counts-table" $hasMeterChart={hasMeterChart}>
      {firstPage.map((value, i) => (
        <Row value={value} total={total} key={value.name} index={i} hasMeterChart={hasMeterChart} />
      ))}
      {!!subsequentPages.length && (
        <>
          {mode === ExpandModes.expand &&
            subsequentPages.map((value, i) => (
              <Row
                value={value}
                total={total}
                key={value.name}
                index={i + AUD_INSIGHTS_TABLES_TRUNCATED_LENGTH}
                hasMeterChart={hasMeterChart}
              />
            ))}
          <ExpansionToggleButton hasMeterChart={hasMeterChart} />
        </>
      )}
    </TableWrapper>
  );
};
